import { render, staticRenderFns } from "./SaveFirstLastVisitBtnDialog.vue?vue&type=template&id=c1ffed50&scoped=true"
import script from "./SaveFirstLastVisitBtnDialog.vue?vue&type=script&lang=js"
export * from "./SaveFirstLastVisitBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ffed50",
  null
  
)

export default component.exports